var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58737 0 0 3.58737 0 8C0 12.4126 3.58737 16 8 16C12.4126 16 16 12.4126 16 8C16 3.58737 12.4126 0 8 0ZM11.3853 8.89263H8C7.51158 8.89263 7.10737 8.48842 7.10737 8V3.84C7.10737 3.35158 7.51158 2.94737 8 2.94737C8.48842 2.94737 8.89263 3.35158 8.89263 3.84V7.12421H11.3853C11.8737 7.12421 12.2779 7.52842 12.2779 8.01684C12.2779 8.48842 11.8737 8.89263 11.3853 8.89263Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon1);
export default __webpack_public_path__ + "static/media/clock-icon-1.71a21e9e4d4d72b21314652eaa4bc30d.svg";
export { ForwardRef as ReactComponent };